<template>
  <div id="app" class="fillcontain">
    <!-- <img src="./assets/logo.png"> -->
    <router-view v-if="isRouterAlive" v-loading="upLoading2"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
        isRouterAlive:true,
    }
  },
  computed:{
    upLoading2(){
      return this.$store.state.fullLoading
    },
  },
  provide(){
    return{
        reload:this.reload
    }
  },
  methods:{
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
          this.isRouterAlive = true
      })
    },
  }
}
</script>

<style lang="less">
	@import './style/common';
</style>



// WEBPACK FOOTER //
// src/App.vue